import * as React from 'react';
import { AppointmentStatus, JsonObject } from '@bb/domain/dist/types';
import { AppointmentDoc } from '@bb/domain/dist/schemas';
import { formatTimeStr } from 'utils';

type PreviousAppointmentDetailProps = {
  appointment: JsonObject<AppointmentDoc>;
};

const StatusText: React.FunctionComponent<{ status: AppointmentStatus }> = ({
  status,
}) => {
  switch (status) {
    case 'confirm':
      return <span style={{ color: 'green' }}>Confirmed</span>;
    case 'cancel':
      return <span style={{ color: 'red' }}>Cancelled</span>;
    case 'deny':
      return <span style={{ color: 'red' }}>Denied</span>;
    case 'time_passed':
      return <span>Time Passed</span>;
    default:
      return null;
  }
};

const PreviousAppointmentDetail = ({
  appointment,
}: PreviousAppointmentDetailProps) => {
  const timeStartString = formatTimeStr(
    appointment.time,
    appointment.listing.timezone,
  );
  const timeEndString = formatTimeStr(
    appointment.timeEnd,
    appointment.listing.timezone,
  );
  const timeText = `${timeStartString} - ${timeEndString}`;

  const listingAddress = `${appointment.listing.line1}${
    appointment.listing.line2 ? `, ${appointment.listing.line2}` : ''
  }`;

  return (
    <div className="row appointment-detail">
      <div className="col-lg-3 appointment-detail__time-container">
        {timeText}
      </div>
      <div className="col-lg-4">{listingAddress}</div>
      <div className="col-lg-2">
        <StatusText status={appointment.status} />
      </div>
      <div className="col-lg-3">
        {appointment.status === 'confirm' &&
          (appointment.feedbackCollected ? (
            <div className="appointment-feedback-submitted">
              Feedback Submitted
            </div>
          ) : (
            <a
              href={`#/my_business/appointment/${appointment.id}/feedback`}
              style={{ color: 'blue' }}
            >
              Leave Feedback
            </a>
          ))}
      </div>
    </div>
  );
};

export default PreviousAppointmentDetail;
